import { z } from 'zod';
import { dateField } from '@shared/schemas';

export const planningCreatedNotificationMetadataSchema = z.object({
	userDetails: z.object({
		name: z.string(),
	}),
	dateFrom: dateField.optional(),
});

export type IPlanningCreatedNotificationMetadata = z.infer<typeof planningCreatedNotificationMetadataSchema>;
